
const displayNameMap: Record<string, string> = {
    Strains: 'Plants/Varieties',
    CBD_physical_characterization: 'Physical Characterization CBD',
    PharmacoDynamics: 'Pharmaco Dynamics',
    Therapeutic_Indicators: 'Therapeutic Indicators',
    Toxicants_Disease: 'Toxicants Disease',
    Cannabis_Compounds: 'Cannabis Compounds',
    Products_Analysis_Methods: 'Products Analysis Methods',
    Products_Analysis_Reports: 'Products Analysis Reports',
    Products_Analysis_Values: 'Products Analysis Values',
    Products_Degradation: 'Products Degradation',
    Products_Degradation_Compounds: 'Products Degradation Compounds',
    CBD_Market: 'CBD Market',
    CBD_PK_Indices: 'CBD PK Indices',

};

export function getDisplayName(key: string): string {
return displayNameMap[key] || key;
}



